import { useContext } from 'react'

// third party libraries
import { useParams } from 'react-router-dom'

// custom components
import ServiceListView from './ServiceListView'
import ServiceListAdmin from './ServiceListAdmin'
import ContactListView from './ContactListView'

// context
import { GlobalContext } from '../../../../services/context/DataContext'

// api

const useServiceList = () => {
  const { tabName } = useParams()
  const {
    selectedServiceData,
    servicesCategorizedByServiceTypeContext,
    activeTabData
  } = useContext(GlobalContext)
  const [, setSelectedService] = selectedServiceData
  const [activeTab, setActiveTab] = activeTabData
  const [servicesCategorizedByServiceType] =
    servicesCategorizedByServiceTypeContext

  const viewSwitcher = ({
    admin,
    selectedChecker,
    handleChange,
    servicesCategorizedByServiceType,
    index,
    data,
    updateCardLabel,
    layoutDefaultData
  }) => {
    if (admin) {
      return (
        <ServiceListAdmin
          layoutDefaultData={layoutDefaultData}
          updateCardLabel={updateCardLabel}
          index={index}
          data={data}
        />
      )
    }
    if (tabName === 'tab1') {
      return (
        <ContactListView
          data={data}
          handleChange={handleChange}
          contactsCategorizedByContactType={servicesCategorizedByServiceType}
          selectedChecker={selectedChecker}
        />
      )
    }

    return (
      <ServiceListView
        data={data}
        handleChange={handleChange}
        servicesCategorizedByServiceType={servicesCategorizedByServiceType}
        selectedChecker={selectedChecker}
      />
    )
  }

  const selectedChecker = id => {
    return activeTab === id
  }

  const handleChange = data => {
    setSelectedService(data)

    if (tabName === 'tab2') {
      setActiveTab(data.service_id)
    } else {
      setActiveTab(data.contact_id)
    }
  }

  return {
    selectedChecker,
    handleChange,
    servicesCategorizedByServiceType,
    viewSwitcher
  }
}

export default useServiceList
